import { CHART_PALETTE } from './chuva-chart-constants';

interface PieLabelProps {
  cx?: number;
  cy?: number;
  midAngle?: number;
  outerRadius?: number;
  value?: number | string;
  index?: number;
}

const renderPieLabel = ({
  cx = 0,
  cy = 0,
  midAngle = 0,
  outerRadius = 0,
  value,
  index = 0,
}: PieLabelProps) => {
  const radius = outerRadius + 18;
  const radians = -midAngle * (Math.PI / 180);
  const x = cx + radius * Math.cos(radians);
  const y = cy + radius * Math.sin(radians);
  return (
    <text
      dominantBaseline="central"
      fill={CHART_PALETTE[index % CHART_PALETTE.length]}
      fontSize={14}
      fontWeight={700}
      textAnchor={x > cx ? 'start' : 'end'}
      x={x}
      y={y}
    >
      {value}
    </text>
  );
};

export default renderPieLabel;
